import React from 'react';
import EventEmitter from 'events';

import util from '../tools/util';
import UserStore from './user_store';

export default {
  init,
  useList,
  useVolumeList,
  useMediaGrant,
  fetch,
  add,
  del,
  update,
  addUser,
  removeUser,
};

const g_orgListMap = new Map<number, any>();

const g_eventEmitter = new EventEmitter();
const CHANGE_EVENT = 'change';
function _emit(...args) {
  g_eventEmitter.emit(CHANGE_EVENT, ...args);
}
function _subscribe(callback: any) {
  g_eventEmitter.on(CHANGE_EVENT, callback);
  return () => {
    g_eventEmitter.removeListener(CHANGE_EVENT, callback);
  };
}
function init(done) {
  done?.();
}
function _getList(org_id: number) {
  return g_orgListMap.get(org_id);
}
export function useList(org_id: number) {
  const _get = React.useCallback(() => _getList(org_id), [org_id]);
  return React.useSyncExternalStore(_subscribe, _get);
}
export function useVolumeList(org_id: number, volume_id: number) {
  const list = useList(org_id);
  return list?.filter?.((g) => g.volume_id === volume_id);
}
export function useMediaGrant(org_id: number, grant_name: string) {
  const grant_lc = grant_name?.toLowerCase?.() ?? '';
  const list = useList(org_id);
  let ret;
  if (list) {
    ret = list.find((g) => g.grant_name.toLowerCase() === grant_lc) || null;
  }
  return ret;
}
function fetch(org_id: number, done?: (err?: any) => void) {
  const opts = { url: `/org_admin/1/org/${org_id}/media_grant` };
  UserStore.get(opts, (err, body) => {
    if (err) {
      util.errorLog('MediaGrantAdminStore.fetch: err:', err);
    } else if (body) {
      const old = g_orgListMap.get(org_id);
      if (!util.deepEqual(old, body.media_grant_list)) {
        g_orgListMap.set(org_id, body.media_grant_list);
        _emit('update');
      }
    }
    done?.(err);
  });
}
function add(params: any, done: (err?: any) => void) {
  const { org_id, ...other } = params;
  const opts = { url: `/org_admin/1/org/${org_id}/media_grant`, body: other };
  UserStore.post(opts, (err, body) => {
    if (err) {
      util.errorLog('MediaGrantAdminStore.add: err:', err);
      done?.(body?.err || err);
    } else {
      fetch(org_id, () => done?.());
    }
  });
}
function del(params: any, done: (err?: any) => void) {
  const { org_id, media_grant_id } = params;
  const opts = {
    url: `/org_admin/1/org/${org_id}/media_grant/${media_grant_id}`,
  };
  UserStore.del(opts, (err) => {
    if (err) {
      util.errorLog('MediaGrantAdminStore.del: err:', err);
      done?.(err);
    } else {
      fetch(org_id, () => done?.());
    }
  });
}
function _edit(params: any, done: (err?: any) => void) {
  const { org_id, media_grant_id, suffix, body } = params;
  const opts = {
    url: `/org_admin/1/org/${org_id}/media_grant/${media_grant_id}${suffix ?? ''}`,
    body,
  };
  UserStore.post(opts, (err) => {
    if (err) {
      util.errorLog('MediaGrantAdminStore._edit: err:', err);
      done?.(err);
    } else {
      fetch(org_id, () => done?.());
    }
  });
}
function update(params: any, done: (err?: any) => void) {
  const { org_id, media_grant_id, ...body } = params;
  _edit({ org_id, media_grant_id, body }, done);
}
function addUser(params: any, done: (err?: any) => void) {
  const { org_id, media_grant_id, user_id } = params;
  _edit(
    { org_id, media_grant_id, suffix: '/add_user', body: { user_id } },
    done
  );
}
function removeUser(params: any, done: (err?: any) => void) {
  const { org_id, media_grant_id, user_id } = params;
  _edit(
    { org_id, media_grant_id, suffix: '/remove_user', body: { user_id } },
    done
  );
}
